import './index.css'

import React, { useCallback } from 'react'
import Slider from 'components/ui/rc-slider'
const SLIDER_HANDLE_STYLE = {
  backgroundImage: 'linear-gradient(180deg, #fff, #f9fafb)',
  border: '1px solid rgba(35, 69, 97, 0.26)',
  boxShadow: '0 1px 0 0 rgba(22, 29, 37, 0.05)',
  width: '18px',
  height: '18px',
  marginLeft: '-7px',
}
const SLIDER_TRACK_STYLE = {
  backgroundColor: 'var(--accent-9)',
}
type Props = {
  volume: number
  onChange: (volume: number) => unknown
}

const VolumePopup = (props: Props): React.ReactElement<'div'> => {
  const handleChange = useCallback(
    (volume: number) => {
      props.onChange(volume / 100)
    },
    [props.onChange],
  )
  return (
    <div className="Player_VolumePopup">
      <div className="Player_VolumePopup_Slider">
        <Slider
          value={props.volume * 100}
          vertical
          onChange={handleChange}
          handleStyle={SLIDER_HANDLE_STYLE}
          trackStyle={SLIDER_TRACK_STYLE}
        />
      </div>
    </div>
  )
}

export default VolumePopup
